"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _round2 = _interopRequireDefault(require("lodash/round"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Displays the average of the values that are not null
 * Settings is passed with 'valuePath' to find the items
 * to add together and get an average
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    var count = 0;
    var sum = 0;
    if (!(0, _isNil2["default"])(row[settings.namePath])) {
      row[settings.namePath].map(function (item) {
        var v = "".concat((0, _get2["default"])(item, settings.valuePath));
        if (!(0, _isNil2["default"])(v) && v !== 'null') {
          sum += +v;
          count++;
        }
        return sum;
      });
    }
    var average;
    if (count > 0) {
      average = settings.decimalPlaces ? (0, _round2["default"])(sum / count, settings.decimalPlaces) : (0, _round2["default"])(sum / count);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: _style["default"].container
    }, average ? /*#__PURE__*/_react["default"].createElement("span", null, "".concat(settings.prefix).concat(average).concat(settings.suffix)) : '');
  };
};